import React from 'react';
import PropTypes from 'prop-types';

import powerboard from './icon-powerboard.svg';
import arrowDownBlack from './icon-arrow-down-black.svg';
import arrowDownWhite from './icon-arrow-down-white.svg';
import arrowUpWhite from './icon-arrow-up-white.svg';
import arrowRightBlack from './icon-arrow-right-black.svg';
import arrowRightWhite from './icon-arrow-right-white.svg';
import arrowTrendGreen from './icon-arrow-trend-green.svg';
import arrowWindDirection from './icon-arrow-wind-direction.svg';
import arrowTrendRed from './icon-arrow-trend-red.svg';
import bellBlack from './icon-bell-black.svg';
import bellWhite from './icon-bell-white.svg';
import checkMarkBlack from './icon-checkmark-black.svg';
import checkMarkGreen from './icon-checkmark-green.svg';
import closeBigBlack from './icon-close-big-black.svg';
import closeBigWhite from './icon-close-big-white.svg';
import closeFilledBlack from './icon-close-filled-black.svg';
import closeFilledGray from './icon-close-filled-gray.svg';
import closeWhite from './icon-close-white.svg';
import hamburgerBlack from './icon-hamburger-black.svg';
import hamburgerWhite from './icon-hamburger-white.svg';
import infoBigBlack from './icon-info-big-black.svg';
import infoBigWhite from './icon-info-big-white.svg';
import infoBlack from './icon-info-black.svg';
import infoWhite from './icon-info-white.svg';
import lightningBig from './icon-lightning-big.svg';
import lightningBlack from './icon-lightning-black.svg';
import lightningBlue from './icon-lightning-blue.svg';
import lightningGray from './icon-lightning-gray.svg';
import lightningWhite from './icon-lightning-white.svg';
import maleBlack from './icon-male-black.svg';
import maleRed from './icon-male-red.svg';
import maleWhite from './icon-male-white.svg';
import userWhite from './icon-user-white.svg';
import note from './icon-note.svg';
import profileBlack from './icon-profile-black.svg';
import profileWhite from './icon-profile-white.svg';
import statusBigBlueRestriction from './icon-status-big-blue-restriction.svg';
import statusBigRedException from './icon-status-big-red-exception.svg';
import statusBlack from './icon-status-black.svg';
import statusRedException from './icon-status-red-exception.svg';
import statusSmallRestriction from './icon-status-small-restriction.svg';
import systemAlertError from './icon-system-alert-error.svg';
import systemAlertOK from './icon-system-alert-ok.svg';
import systemAlertWarning from './icon-system-alert-warning.svg';
import yellowDot from './icon-yellow-dot.svg';
import technicalIssue from './icon-technical-issue.svg';
import incompleteData from './icon-incomplete-data.svg';
import dataMissing from './icon-data-missing-black.svg';
import styled from '@emotion/styled';

export const pbIcons = {
    powerboard,
    arrowDownBlack,
    arrowDownWhite,
    arrowUpWhite,
    arrowRightBlack,
    arrowRightWhite,
    arrowTrendGreen,
    arrowTrendRed,
    arrowWindDirection,
    bellBlack,
    bellWhite,
    checkMarkBlack,
    checkMarkGreen,
    closeBigBlack,
    closeBigWhite,
    closeFilledBlack,
    closeFilledGray,
    closeWhite,
    hamburgerBlack,
    hamburgerWhite,
    infoBigBlack,
    infoBigWhite,
    infoBlack,
    infoWhite,
    lightningBig,
    lightningBlack,
    lightningBlue,
    lightningGray,
    lightningWhite,
    maleBlack,
    maleRed,
    maleWhite,
    userWhite,
    note,
    profileBlack,
    profileWhite,
    statusBigBlueRestriction,
    statusBigRedException,
    statusBlack,
    statusRedException,
    statusSmallRestriction,
    systemAlertError,
    systemAlertOK,
    systemAlertWarning,
    yellowDot,
    technicalIssue,
    incompleteData,
    dataMissing,
};

const Img = styled.img`
    vertical-align: middle;
    height: ${(p) => p.height};
    width: ${(p) => p.width};
    max-width: initial;
`;

export const Icon = ({ type, width, height, ...props }) => (
    <Img
        {...props}
        src={pbIcons[type] || '#'}
        alt={`Icon for ${type}`}
        width={width ? `${width}px` : 'auto'}
        height={height ? `${height}px` : 'auto'}
    />
);

Icon.propTypes = {
    type: PropTypes.string.isRequired,
    width: PropTypes.number,
    height: PropTypes.number,
};
